import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { CompactPageLayout } from 'common/components/compactPageLayout';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import RolesDetails from './components/rolesTab/components/rolesDetails/RolesDetails';
import RolesList from './components/rolesTab/components/rolesList/RolesList';
import styles from './AdminRolesScreen.module.scss'
import Button from 'common/components/button/Button';
import ReactTooltip from 'react-tooltip';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';
import Loading from 'common/services/Loading';
import Logger from 'common/services/Logger';
import { LOGGER_LOG_TYPE } from 'Config';
import { useToasts } from 'react-toast-notifications';
import RolesService from 'api/roles/RolesService';

const AdminRolesSecurity = () => {
    const { t } = useTranslation();
    const { tabId, tabType, id } = useParams<{ tabId: string, tabType: string, id: string }>();

    const [showSyncModal, setShowSyncModal] = useState<boolean>(false);
        const { addToast } = useToasts();
        const syncAdminNotifications = async () => {

        setShowSyncModal(false);
        try {
            Loading.show();
            await RolesService.syncAdminRoles();
            addToast(t('common.messages.record_finish_success'), { appearance: 'success' });

            Loading.hide();

        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.REQUEST, `Couldn't syncronize admin notifications`, error);
            addToast(t('common.messages.record_finish_error'), { appearance: 'error' });
            Loading.hide();
        }
    };

    const onCancelSync = () => {
        setShowSyncModal(false);
    };

    
    return (<ScreenTitle title={t('roles.title')}>
        <CompactPageLayout title={t('roles.title') as string} headerButtons={!tabType ? <>
                    <div data-tip={t('roles.sync_admin_roles_message')}>
                        <Button onClick={() => setShowSyncModal(true)} style={{ padding: '0.5rem 1.8rem' }}>{t('notifications.sync_admin_notifications')}</Button>
                    </div>
                    <ReactTooltip />
                </> : undefined}>
            <div className={styles.content}>
                {tabType ? <RolesDetails isAdmin={true} /> : <RolesList isAdmin={true} />}
            </div>
            <QuestionYesNo
                onNo={onCancelSync}
                onYes={syncAdminNotifications}
                isVisible={showSyncModal}
                message={t('notifications.confirm_sync_admin_notifications')} />
        </CompactPageLayout>
    </ScreenTitle>)
}

export default AdminRolesSecurity;